import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import config from 'universal-config';
import { decorateWith, withName } from 'helpers/decorator';
import { setAvailable, setLoading } from './optimizely.saga';

export class OptimizelySDKUnwrapped extends Component {
  componentDidMount() {
    if (!this.constructor.hasInitialized) {
      this.constructor.hasInitialized = true;
      this.props.setLoading();

      // Ensure a "push" interface
      window.optimizely = window.optimizely || [];

      // Optimizely might take awhile to load.  We want to know when it finishes
      window.optimizely.push({
        type: 'addListener',
        filter: { type: 'lifecycle', name: 'initialized' },
        handler: this.props.setAvailable,
      });

      // Optimizely may have loaded before the listener was in place to fire
      if (!Array.isArray(window.optimizely)) {
        this.props.setAvailable();
      }

      // Check eligibility for experiments on each page change
      document.body.addEventListener('historyChanged', () => window.optimizely.push({ type: 'activate' }));
    }
  }

  render() {
    return (
      <Helmet>
        <link rel="preload" as="script" href={`https://cdn.optimizely.com/js/${config().optimizely.projectId}.js`} />
        <link rel="dns-prefetch" href="//logx.optimizely.com" />
        <link rel="preconnect" href="//logx.optimizely.com" crossOrigin="anonymous" />
        <script src={`https://cdn.optimizely.com/js/${config().optimizely.projectId}.js`} defer />
      </Helmet>
    );
  }
}

OptimizelySDKUnwrapped.hasInitialized = false;
OptimizelySDKUnwrapped.propTypes = {
  setAvailable: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
};

export const OptimizelySDK = decorateWith(
  connect(
    null,
    { setAvailable, setLoading }
  ),
  withName('OptimizelySDK')
)(OptimizelySDKUnwrapped);
